import React, { useState, useEffect } from "react";
import { Dialog } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';

import { theme } from "../../constants/theme";
import ButtonGroupCustom from "../button_group";

import SignIn from "./account_signin";
import AccountOrder from "./account_order";
import OrderDetail from "./account_order_detail";
import OrderCard from "./account_card";
import OrderEBarimt from "./account_ebarimt";
import ForgotPass from "./forgot_pass";

const actionTypes = {
  signin: 0,
  order: 1,
  orgaCartOrder: 2,
  personCartOrder: 3,
  cardDetail: 4,
  orderBarimt: 5,
  forgotPass: 6
}

const orderTypes = {
  person: 'person',
  organization: 'organization'
}

const AccountDialog = ({ open = false, toggle }) => {

  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [step, setStep] = useState(0)
  const [actionType, setActionType] = useState(0)
  const [routes, setRoutes] = useState([0])

  const onCancel = (e, reason) => {
    if (reason && reason === "backdropClick") return;
    toggle(false);
  };

  const onBack = () => {
    if (routes.length === 0) return;
    let tmpRoutes = routes;
    tmpRoutes.pop()
    setActionType(tmpRoutes[tmpRoutes.length - 1])
    setRoutes(tmpRoutes)
    setStep(step-1)
  }

  const onNext = (newIndex) => {
    setStep(step + 1)
    if (routes[routes.length - 1] !== newIndex)
      setRoutes([...routes, newIndex])
    setActionType(newIndex)
  }

  const onChangeTab = (newIndex) => {
    if (routes[routes.length - 1] !== newIndex)
      setRoutes([...routes, newIndex])
    setActionType(newIndex)
  }

  const onSelectCart = (index) => {
    onNext(index)
  }

  const onSubmitDetail = () => {
    onNext(actionTypes.cardDetail)
  }

  const onSubmitQuantity = () => {
    onNext(actionTypes.orderBarimt)
  }

  const forgotPass = () => {
    onNext(actionTypes.forgotPass)
  }

  const getBody = () => {
    switch (actionType) {
      case actionTypes.signin: 
        return <SignIn closeDialog={onCancel} forgotPass={forgotPass}/>;
      case actionTypes.order: 
        return <AccountOrder onSelect={onSelectCart}/>;
      case actionTypes.orgaCartOrder: 
        return <OrderDetail type={orderTypes.organization} onSubmit={onSubmitDetail}/>;
      case actionTypes.personCartOrder: 
        return <OrderDetail type={orderTypes.person} onSubmit={onSubmitDetail}/>;
      case actionTypes.cardDetail: 
        return <OrderCard onSubmit={onSubmitQuantity}/>;
      case actionTypes.orderBarimt: 
        return <OrderEBarimt />;
      case actionTypes.forgotPass: 
        return <ForgotPass />;
      default:
        return <></>
    }
  }

  useEffect(() => {
    if (!open) {
      setStep(0)
      setActionType(0)
      setRoutes([0])
    }
  }, [open])

  return (
    <Dialog 
      fullScreen={fullScreen ?? false} 
      open={open} 
      onClose={onCancel}>
      <div className="dialog-header">
        {
          step === 0 ? 
            <div className="buttom-group-container">
              <ButtonGroupCustom
                active={actionType}
                setActive={onChangeTab}
                items={['Нэвтрэх', 'Карт Захиалах']}
              />
            </div> : 
            <button className="fab-btn" onClick={onBack}>
              <img alt="close" src="/images/arrow_back.svg" height={13} />
            </button>
        }
        <button className="fab-btn" onClick={() => toggle(false)}>
          <img alt="close" src="/images/close.svg" height={11} />
        </button>
      </div>
      <div className="account-dialog-container dialog-body bg-white">
        <div className="my-6 d-flex justify-content-center">
          <img alt="logo" src="/images/logo_name.png" height={100} width="auto"/>
        </div>
        {getBody()}
      </div>
    </Dialog>
  );
};

export default AccountDialog;
